export default __webpack_public_path__ + "static/media/creategroupcolor.2806ce8a.png";